import { Link } from 'react-router-dom';
import { Button } from '../../../../shared/components/Buttons';
import { TextField } from '../../../../shared/components/TextField';
import { Mail, Lock, Eye, EyeOff } from 'react-feather';
import { useLoginForm } from '../../hooks/useLoginForm';

interface LoginFormProps {
  onLoginSuccess?: (email: string) => void;
  isTablet?: boolean;
}

const LoginForm = ({ onLoginSuccess, isTablet = false }: LoginFormProps) => {
  const {
    showPassword,
    emailField,
    passwordField,
    displayPassword,
    globalError,
    isSubmitting,
    passwordInputRef,
    handleTogglePassword,
    handleEmailChange,
    handleEmailClear,
    handlePasswordChange,
    handleSubmit,
  } = useLoginForm({ onLoginSuccess });

  return (
    <form
      onSubmit={handleSubmit}
      className={`flex  flex-col gap-[38px] ${isTablet ? 'w-full' : 'w-[360px]'}`}
    >
      <div className=" flex flex-col gap-[40px]">
        <div className="flex flex-col gap-[8px]">
          <h1 className="font-[400]  text-[28px] text-neutral-10 ">Witamy!</h1>
          <p className="text-bodyMedium text-on-surface-variant">
            Wprowadź swój adres e-mail oraz hasło, aby się zalogować.
          </p>
        </div>
        <div className="flex items-start justify-start flex-col gap-[18px]">
          <div className="flex flex-col gap-[24px] w-full">
            <TextField
              label="Adres e-mail"
              showClearButton={true}
              error={emailField.hasError}
              fullWidth={true}
              labelColor="#474A4C"
              leadingIcon={<Mail size={24} color="#474A4C" />}
              errorMessage={emailField.errorMessage}
              value={emailField.value}
              onChange={
                handleEmailChange as (
                  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
                ) => void
              }
              onClear={handleEmailClear}
              disabled={isSubmitting}
              autoFocus={true}
              maxLength={100}
            />
            <TextField
              ref={passwordInputRef}
              label="Hasło"
              showClearButton={false}
              error={passwordField.hasError}
              errorMessage={passwordField.errorMessage}
              fullWidth={true}
              labelColor="#474A4C"
              leadingIcon={<Lock size={24} color="#474A4C" />}
              value={displayPassword}
              onChange={
                handlePasswordChange as (
                  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
                ) => void
              }
              disabled={isSubmitting}
              trailingIcon={
                <button
                  type="button"
                  onClick={handleTogglePassword}
                  onMouseDown={(e) => e.preventDefault()}
                  aria-label={showPassword ? 'Ukryj hasło' : 'Pokaż hasło'}
                  disabled={isSubmitting}
                  className="rounded focus:outline-none focus:ring-2 focus:ring-primary-color-40 disabled:cursor-not-allowed enabled:cursor-pointer"
                >
                  {showPassword ? (
                    <EyeOff size={24} color="#474A4C" />
                  ) : (
                    <Eye size={24} color="#474A4C" />
                  )}
                </button>
              }
              type="text"
              maxLength={200}
            />
          </div>
          {globalError &&
            !passwordField.errorMessage &&
            !emailField.errorMessage && (
              <p className="text-[12px] font-normal leading-[16px] tracking-[0.4px] text-[#E11B1B]">
                Błędny e-mail lub hasło.
              </p>
            )}

          <Link
            to="/forgot-password"
            className="text-labelLarge text-primary-color-40 hover:cursor-pointer"
          >
            Zapomniałeś hasła?
          </Link>
        </div>
      </div>
      <Button
        color="primary"
        label={isSubmitting ? 'Logowanie…' : ' Zaloguj się'}
        size="Medium"
        className={isSubmitting ? 'cursor-not-allowed' : 'cursor-pointer'}
        disabled={isSubmitting}
        buttonType="Square"
        type="submit"
      />
    </form>
  );
};

export default LoginForm;
